module.exports = __webpack_public_path__ + "img/scissors_comb_one_hand.cb23530f.jpg";